import React, { useState } from 'react';
import { fetchConToken } from 'helpers/fetch';
import AsyncSelect from 'react-select/async';
import { useTranslation } from "react-i18next";

const GeneralForm = ({ data, handleInputChange, onChangeCheckActivo, onChangeCheck, Save, onClose, isGeneralForm }) => {
    const { t } = useTranslation("common");
    const isAddMode = !data.publicado;
    const [articulo, setArticulo] = useState(data);
    const [initialObject, setInitialObject] = useState(true);
    const [initialObjectClaveUnidad, setInitialObjectClaveUnidad] = useState(true);
    const loadData = async (query) => await fetchConToken(`CatalogosSat/ListClaveProd?pagina=${1}&totalXpagina=${50}&busqueda=${query}`);
    const loadDataClaveUnidad = async (query) => await fetchConToken(`CatalogosSat/ListClaveUnidad?pagina=${1}&totalXpagina=${50}&busqueda=${query}`);
    const SaveArt = () => Save(articulo);

    const _onChangeCheck = (e) => {
        if (onChangeCheck) onChangeCheck(e);

        const xCheck = e.target.checked ? 'S' : 'N';
        setArticulo({
            ...articulo,
            [e.target.name]: xCheck
        });
    };

    const _onChangeCheckActivo = (e) => {
        if (onChangeCheckActivo) onChangeCheckActivo(e);

        const xCheck = e.target.checked ? 'A' : 'I';
        setArticulo({
            ...articulo,
            [e.target.name]: xCheck
        });
    };

    function _handleInputChange(event) {
        if (handleInputChange) handleInputChange(event);

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        setArticulo({
            ...articulo,
            [name]: value
        });
    }

    const GetGeneralForm = () => <div className='row'>
        <div className='col-md-6' style={{ display: 'grid' }}>
            <div className='card mb-3 '>
                <label className='form-label title2'>{t('app.Articulos.datosGenerales')}</label>
                <div className='card-body text-start'>
                    <label htmlFor='clave' className='form-label'>{t('app.Articulos.form.claveArt')}</label>
                    <input
                        type='text'
                        className={isAddMode ? 'form-control' : 'form-control form-control-disabled'}
                        name='clave'
                        maxLength={100}
                        value={articulo.clave || ''}
                        disabled={!isAddMode}
                        onChange={_handleInputChange}
                    />
                    <label htmlFor='nombre' className='form-label'>{t('app.Articulos.form.nombreArt')}*</label>
                    <input
                        type='text'
                        className='form-control'
                        name='nombre'
                        required={true}
                        maxLength={100}
                        value={articulo.nombre || ''}
                        onChange={_handleInputChange}
                    />
                    <label htmlFor='sku' className='form-label'>SKU</label>
                    <input
                        type='text'
                        className='form-control'
                        name='sku'
                        maxLength={100}
                        value={articulo.sku || ''}
                        onChange={_handleInputChange}
                    />
                    <label htmlFor='existencias' className='form-label'>{t('app.Articulos.form.existencias')}*</label>
                    <input
                        type='number'
                        className='form-control'
                        name='existencias'
                        required={true}
                        maxLength={100}
                        value={articulo.existencias || ''}
                        onChange={_handleInputChange}
                    />
                    <div className='col-md-12 row'>
                        <div className='col-sm-5'>
                            <div className='espacio15px' />
                            <div className='form-check form-switch margin_left_switch'>
                                <input
                                    type='checkbox'
                                    className='form-check-input'
                                    name='estatus'
                                    role='switch'
                                    onChange={_onChangeCheckActivo}
                                    checked={articulo.estatus === 'A'}
                                />
                                <label htmlFor='estatus' className='margin_left_switch margin_top_switch_label'>{t('app.Articulos.form.estatus')}</label> &nbsp;&nbsp;
                            </div>
                        </div>
                        <div className='col-sm-6'>
                            <div className='espacio15px' />
                            <div className='form-check form-switch margin_left_switch'>
                                <input
                                    type='checkbox'
                                    className='form-check-input'
                                    name='es_Paquete'
                                    role='switch'
                                    onChange={_onChangeCheck}
                                    checked={articulo.es_Paquete === 'S'}
                                />
                                <label htmlFor='es_Paquete' className='margin_left_switch margin_top_switch_label'>{t('app.Articulos.form.esPaquete')}</label> &nbsp;&nbsp;
                            </div>
                        </div>
                    </div>
                    <label htmlFor='url' className='form-label'>URL</label>
                    <input
                        type='text'
                        className={isAddMode ? 'form-control' : 'form-control form-control-disabled'}
                        name='url'
                        maxLength={100}
                        value={articulo.url || ''}
                        onChange={_handleInputChange}
                        disabled={true}
                    />
                </div>
            </div>
        </div>
        <div className='col-md-6' style={{ display: 'grid' }}>
            <div className='card mb-3 '>
                <label className='form-label title2'>{t('app.Articulos.datosSat')}</label>
                <div className='card-body text-start'>
                    <label htmlFor='no_Identificacion' className='form-label'>{t('app.Articulos.form.codigoIdentificacion')}*</label>
                    <input
                        type='text'
                        className='form-control'
                        name='no_Identificacion'
                        required={true}
                        maxLength={100}
                        placeholder="Escriba código de identificación"
                        value={articulo.no_Identificacion || ''}
                        onChange={_handleInputChange}
                    />
                    <label htmlFor='clave_Prod_Serv' className='form-label'>{t('app.Articulos.form.servicioSAT')}</label>
                    <AsyncSelect
                        isClearable
                        className='react-select-placeholder'
                        getOptionLabel={(option) => option.clave + ' - ' + option.nombre}
                        getOptionValue={(option) => option.clave}
                        defaultOptions
                        value={initialObject}
                        loadOptions={loadData}
                        onChange={(selectedItem) => {
                            const val = selectedItem === null ? '' : selectedItem?.clave;
                            articulo.clave_Prod_Serv = val;
                            setArticulo({ ...articulo, clave_Prod_Serv: val });
                            setInitialObject(selectedItem);
                        }}
                    />
                    <label htmlFor='clave_Unidad' className='form-label'>{t('app.Articulos.form.claveUnidad')}*</label>
                    <AsyncSelect
                        className='react-select-placeholder'
                        isClearable
                        getOptionLabel={(option) => option.clave + ' - ' + option.nombre}
                        getOptionValue={(option) => option.clave}
                        defaultOptions //={initialObjectClaveUnidad}
                        value={initialObjectClaveUnidad}
                        loadOptions={loadDataClaveUnidad}
                        onChange={(selectedItem) => {
                            const val = selectedItem === null ? '' : selectedItem?.clave;
                            articulo.clave_Unidad = val;
                            setArticulo({ ...articulo, clave_Unidad: val });
                            setInitialObjectClaveUnidad(selectedItem);
                        }}
                    />
                </div>
            </div>
        </div>
        <div className='container-fluid'></div>
    </div>;

    return isGeneralForm ? (<div style={{ display: 'flex', flexDirection: 'column', maxHeight: '80vh' }}>
        <div className='espacio15px' />
        <div className='espacio15px' />
        <div style={{ overflowY: 'auto', overflowX: 'hidden', flex: '1 1 auto', minHeight: '65vh' }}>{GetGeneralForm()}</div>
        <div className='espacio5px' />
        <div className='row'>
            <div className='col-sm-8' />
            <div className='col-sm-2'>
                <button className='btn btn-outline-danger' onClick={onClose}>
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='20'
                        height='20'
                        fill='currentColor'
                        className='bi bi-x-lg'
                        viewBox='0 0 16 16'
                    >
                        <path d='M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z' />
                    </svg>
                    &nbsp; &nbsp; {t('app.botones.cancelar')}
                </button>
            </div>
            <div className='col-sm-2'>
                <button className='btn btn-outline-success' onClick={SaveArt}>
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='20'
                        height='20'
                        fill='currentColor'
                        className='bi bi-check-lg'
                        viewBox='0 0 16 16'
                    >
                        <path d='M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z' />
                    </svg>
                    &nbsp; {t('app.botones.guardar')}
                </button>
            </div>
        </div>
    </div>) : (<div>{GetGeneralForm()}</div>);
}

export { GeneralForm };